import { Action, Dispatch } from 'redux';
import { getLocalizationsBySport } from '../api/vault/localization/api';
import { ILocalization } from '../api/vault/localization/interfaces';
import { SPORT_LOCALIZATION_STORAGE_KEY } from '../constants';
import { LocalizationLabels } from '../enums';
import { IAppState } from './reducers';

export interface IState {
  locales: ILocalization[];
}

export enum ActionType {
  UpdateLocalization = 'Localization.UpdateLocalization',
}
export interface ILocalizationAction extends Action<ActionType> {
  payload?: any,
}

const getStoredLocales = (): ILocalization[] => {
  try {
    const stored = localStorage.getItem(SPORT_LOCALIZATION_STORAGE_KEY);
    if (stored && stored !== 'undefined') {
      return JSON.parse(stored);
    }
  } catch (e) {
    // Invalid JSON in localStorage
  }
  return [];
};

export const INITIAL_STATE: IState = {
  locales: getStoredLocales(),
};

export default function reducer(state: IState = INITIAL_STATE, action: ILocalizationAction): IState {
  switch (action.type) {
    case ActionType.UpdateLocalization:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const getLocalization = (sport: string) => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  // Add locales to local storage everytime they are retrieved from the api
  const localization = (await getLocalizationsBySport(sport)).data.data;
  dispatch({
    payload: {
      locales: localization,
    },
    type: ActionType.UpdateLocalization,
  });
  localStorage.setItem(SPORT_LOCALIZATION_STORAGE_KEY, JSON.stringify(localization));
};

// Retrieves locale from current localization and returns the value of that locale
export const getLocale = (state: IAppState, label: LocalizationLabels): string => {
  const foundLocale = state.localization?.locales?.find((locale) => locale.label === label);
  return foundLocale ? foundLocale.value : '';
};
